import * as actions from './actionTypes';
import { MaintenanceMessage } from 'api';

export interface IMaintenanceStore {
    initialized: boolean,
    status: Array<MaintenanceMessage>,
    newStatus: Array<MaintenanceMessage>,
    seen: boolean
}

export const INITIAL_STATE: IMaintenanceStore = {
    initialized: false,
    status: [],
    newStatus: [],
    seen: false
}

const Maintenance = (state = INITIAL_STATE, action: { type: string, payload: any }) => {
    switch (action.type) {

        case actions.APP_INITIALIZED:
            state = {
                ...state,
                initialized: action.payload
            }
            break;

        case actions.SET_MAINTENANCE_STATUS:
            state = {
                ...state,
                status: [...action.payload],
                seen: false
            }
            break;

        case actions.SET_NEW_MAINTENANCE:
            state = {
                ...state,
                newStatus: [action.payload, ...state.newStatus]
            }
            break;

        case actions.MAINTENANCE_STATUS_SEEN:
            state = {
                ...state,
                newStatus: [],
                seen: true
            }
            break;

        default:
            state = { ...state };
            break;
    }
    return state;
}

export default Maintenance;